(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/pages/search-results.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/pages/search-results.js');

'use strict';

const Searchbar = svs.grassroots.components.searchbar_section.Searchbar;
const SearchResultsList = svs.grassroots.components.search_results.SearchResultsList;
const {
  grassrootsQueryApi
} = svs.grassroots.store;
const {
  useLocation,
  useHistory
} = ReactRouterDOM;
const {
  Loader
} = svs.components.ReactLoader;
const {
  Button,
  ReactIcon: Icon
} = svs.ui;
const {
  Card,
  CardBody
} = svs.ui.ReactCard;
const {
  useState,
  useEffect
} = React;
const SearchResults = _ref => {
  let {
    resultPage = false
  } = _ref;
  const {
    search
  } = useLocation();
  const [searchterm, setSearchterm] = useState('');
  const [numResponses, setNumResponses] = useState(5);
  const {
    data,
    isLoading
  } = grassrootsQueryApi.useFetchReceiversSearchQuery({
    searchterm,
    numResponses
  });
  const history = useHistory();
  useEffect(() => {
    if (search.includes('?q=')) {
      setSearchterm(decodeURIComponent(search.slice(3)));
    }
  }, []);
  const fetchReceiversHandler = e => e.preventDefault();
  const onChangeHandler = e => {
    setNumResponses(5);
    setSearchterm(e.currentTarget.value);
    if (!resultPage) {
      history.replace({
        pathname: 'sok',
        search: "?q=".concat(encodeURIComponent(e.currentTarget.value)),
        state: {
          isActive: true
        }
      });
    }
  };
  const fetchMoreClicked = () => {
    setNumResponses(50);
  };
  return React.createElement(Card, {
    branding: svs.grassroots.tenant,
    className: "search-result-container f-content"
  }, React.createElement(CardBody, null, !resultPage && React.createElement(Button, {
    className: "btn-icon-left margin-top-1 search-result-back-button",
    onClick: () => history.push('/')
  }, React.createElement(Icon, {
    icon: "arrow-left",
    size: 100
  }), "Tillbaka"), React.createElement("div", {
    className: "search-result-body"
  }, React.createElement("h1", {
    className: "align-center"
  }, "S\xF6k f\xF6reningar h\xE4r"), React.createElement("p", {
    className: "align-center"
  }, "Du som valt f\xF6rening/-ar i Gr\xE4sroten f\xE5r automatiskt en avisering via e-post n\xE4r \xE5rets f\xF6rdelning \xE4r f\xE4rdig."), React.createElement("p", {
    className: "align-center margin-bottom-2"
  }, "Det kostar ingenting att vara med."), React.createElement(Searchbar, {
    displayResults: false,
    onChange: onChangeHandler,
    onSubmit: fetchReceiversHandler,
    searchResult: data === null || data === void 0 ? void 0 : data.receivers,
    searchterm: searchterm
  })), isLoading && !(data !== null && data !== void 0 && data.receivers) ? React.createElement(Loader, null) : Boolean(data === null || data === void 0 ? void 0 : data.receivers.length) && data.receivers.length > 0 && React.createElement("div", {
    className: "search-result-list margin-top-1"
  }, React.createElement("p", {
    className: "margin-left-1"
  }, "S\xF6kresultat f\xF6r:", searchterm, ' ', "- [", data.numberfound, "] matchningar."), React.createElement(SearchResultsList, {
    receivers: data.receivers,
    resultPage: true,
    searchterm: searchterm
  }), React.createElement("div", {
    className: "align-center w100 padding-bottom-4"
  }, numResponses < 50 && React.createElement(Button, {
    className: "fetch-more-btn",
    onClick: fetchMoreClicked,
    transparent: true
  }, "H\xE4mta fler")))));
};
svs.grassroots.pages.SearchResults = SearchResults;

 })(window);